import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Globe, ChevronRight, User } from 'lucide-react';

// SidebarProfileCard - small "public profile" entry shown in the Dashboard
// sidebars (both desktop and the mobile drawer) below the logo. Tapping
// it deep-links to the user's own public profile so they can preview what
// the world sees. The "Public" badge only renders when they have at
// least one item marked share_visibility=public - otherwise the card
// stays passive (signalling "go make something public").
export const SidebarProfileCard = ({ user, hasPublicItems = false, onClick }) => {
    const navigate = useNavigate();
    if (!user) return null;

    const handleClick = () => {
        if (onClick) onClick();
        if (user.username) {
            navigate(`/${user.username}`);
        }
    };

    const firstName = (user.name || user.username || '').split(' ')[0] || 'You';

    return (
        <button
            type="button"
            onClick={handleClick}
            data-testid="sidebar-profile-card"
            className="w-full flex items-center gap-3 px-3 py-3 mb-3 rounded-2xl bg-gradient-to-br from-emerald-50 to-emerald-100/40 border border-emerald-200/60 hover:border-emerald-300 hover:shadow-sm transition-all text-left group"
        >
            {user.picture ? (
                <img
                    src={user.picture}
                    alt={firstName}
                    className="w-10 h-10 rounded-full object-cover ring-2 ring-white shadow-sm flex-shrink-0"
                />
            ) : (
                <div className="w-10 h-10 rounded-full bg-emerald-600 flex items-center justify-center ring-2 ring-white shadow-sm flex-shrink-0">
                    <User className="w-5 h-5 text-white" />
                </div>
            )}
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                    <span className="text-sm font-semibold text-[#1F2D20] truncate">
                        {firstName}'s BrainSync
                    </span>
                    {hasPublicItems && (
                        <span
                            className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-emerald-600 text-white text-[9px] font-bold tracking-wide uppercase flex-shrink-0"
                            data-testid="sidebar-profile-public-badge"
                        >
                            <Globe className="w-2.5 h-2.5" strokeWidth={2.4} />
                            Public
                        </span>
                    )}
                </div>
                <div className="text-[11px] text-emerald-700/70 truncate font-mono mt-0.5">
                    brainsync.pro/{user.username || '…'}
                </div>
            </div>
            <ChevronRight className="w-4 h-4 text-emerald-700/40 group-hover:text-emerald-700 transition-colors flex-shrink-0" />
        </button>
    );
};

export default SidebarProfileCard;
